import { Grid, Group, Layout, Page } from "@/comn/components";
import { URLS } from "@/tra/tancis/ptli/ptl/authmenu/services/PtliAuthMenuService";
import * as authService from "@/tra/tancis/ptli/ptl/auth/services/PtliAuthService";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { Link } from "react-router-dom";

/*
 * Auth and Menu Link List
 * !== 권한 및 메뉴 연결 목록 ==!
 */
export const PTLI1015001Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0002"],
    });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = {
        authSrch: useForm({
            defaultSchema: authService.SF_AUTH_MGMT_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        authList: useGrid({
            defaultSchema: authService.SG_AUTH_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                authService.APIS.getAuthList(form.authSrch.getValues(), page, size),
            enabled:
                !comnUtils.isEmpty(form.authSrch.getValue("bsopClsfCd")) &&
                !comnUtils.isEmpty(form.authSrch.getValue("ptlTpCd")),
            key: [grid.authList.page, grid.authList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.authSrch.getValues(),
                    page: grid.authList.page,
                    size: grid.authList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSrchBtnClick: form.authSrch.handleSubmit(
            () => {
                grid.authList.setPage(0);
                fetch.getAuthList.fetch(0);
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onGridCellClick: (cell: any) => {
            const { binding, rowValues } = cell;
            if (binding !== "authId") return;

            setStore(pgeUid, {
                ...pgeStore,
                param: {
                    bsopClsfCd: rowValues.bsopClsfCd,
                    ptlTpCd: rowValues.ptlTpCd,
                    authId: rowValues.authId,
                },
            });
        },
    };

    const render = {
        authList: {
            cell: {
                authId: (props: any) => {
                    const { value } = props;
                    return <Link to={`${URLS.ptli1015002s}/${value}`}>{value}</Link>;
                },
            },
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.authSrch.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.authId} />
                            <Group.Control {...form.authSrch.schema.authNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Grid
                        {...grid.authList.grid}
                        data={fetch.getAuthList.data?.authList}
                        render={render.authList}
                        onCellClick={handler.onGridCellClick}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
